import { IProject } from 'holberton-school-intranet-api';
import * as React from 'react';
import { ReactElement } from 'react';

import Tooltip from '../../common/Tooltip';

interface IProps {
    project: IProject;
    size: number;
    alwaysShowMandatoryScore?: boolean;
    showFullTitle?: boolean;
    hideTitle?: boolean;
}

export default function ProjectCircleLabel({
    project,
    size,
    alwaysShowMandatoryScore = false,
    showFullTitle = false,
    hideTitle = false,
}: IProps): ReactElement {
    const mandatoryScore = alwaysShowMandatoryScore 
        ? (project.score.mandatory ?? 0)
        : project.score.mandatory;
    const hasScores = alwaysShowMandatoryScore 
        || project.score.mandatory !== null 
        || project.score.optional !== null;

    return (
        <div
            className="p-1 position-absolute project-circle-score text-center"
            style={{
                borderRadius: 10,
                width: showFullTitle ? 'auto' : 85,
                maxWidth: showFullTitle ? '100%' : 85,
                minWidth: showFullTitle ? 120 : undefined,
                left: '50%',
                transform: 'translateX(-50%)',
            }}
        >
            {!hideTitle && (
                <Tooltip title={project.name}>
                    <div className="project-title" style={{
                        fontSize: '12px',
                        fontWeight: 600,
                        marginBottom: hasScores ? '2px' : '0',
                        overflow: showFullTitle ? 'visible' : 'hidden',
                        textOverflow: showFullTitle ? 'clip' : 'ellipsis',
                        whiteSpace: showFullTitle ? 'normal' : 'nowrap',
                        color: '#333'
                    }}>
                        {project.name}
                    </div>
                </Tooltip>
            )}
            {(alwaysShowMandatoryScore || project.score.mandatory !== null) && (
                <Tooltip title={window.I18n.t('projects.score_mandatory_tasks', 'Score of Mandatory Tasks')}>
                    <span className="d-block">{mandatoryScore}%</span>
                </Tooltip>
            )}

            {project.isOptional && project.score.optional === 0 && (
                <small className="text-muted">
                    {size >= 90 && window.I18n.t('projects.advanced', 'Advanced')}
                    {size < 90 && window.I18n.t('projects.advanced_abbr', 'Advan.')}
                </small>
            )}

            {project.score.optional > 0 && (
                <Tooltip title={window.I18n.t('projects.score_advanced_tasks', 'Score of Advanced Tasks')}>
                    <small className="text-muted">
                        {project.score.optional}%
                    </small>
                </Tooltip>
            )}
        </div>
    );
}
